import { TypedDocumentNode } from '@graphql-typed-document-node/core'

export type GraphQLCacheKey = [
  TypedDocumentNode<unknown, Record<string, unknown>>,
  Record<string, unknown>,
]

export const generateGraphQLCacheKey = <
  TResult,
  TVariables extends Record<string, unknown>,
>(
  query: TypedDocumentNode<TResult, TVariables>,
  variable: TVariables,
): GraphQLCacheKey => [query, variable] as GraphQLCacheKey

export type CacheKey = string | GraphQLCacheKey
